import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { setQboAuthorizationUrl, setBusinessList, componentKey as qboComponentKey, setChartOfAccounts, setFormBoxLabels, setFormAndTaxYearList, setImportData, setFormSettings, setIsImportDataGridViewLoaded, setLoadingState } from "./QboSlice";
import IntegrationDataService from "../../../../../services/IntegrationDataService";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import FormsDataService from "../../../../../services/FormsDataService";
import { QBO_LOADING_STATES } from "../constants";

export const { getQboUrl, connectToQbo, disconnectToQbo, getChartOfAccounts, getFormLabels, getFormAndTaxYearList, getLoadImportData, getFormSetting } = {
    getQboUrl: (payload) => {
        return {
            type: "QBO/GET_AUTHENTICATEURL",
            payload: payload
        }
    },
    connectToQbo: (payload) => {
        return {
            type: "QBO/GET_CONNECTQBO",
            payload: payload
        }
    },
    disconnectToQbo: (payload) => {
        return {
            type: "QBO/GET_DISCONNECTQBO",
            payload: payload
        }
    },
    getChartOfAccounts: (payload) => {
        return {
            type: "QBO/GET_GETCOA",
            payload: payload
        }
    },
    getFormLabels: (payload) => {
        return {
            type: "QBO/GET_GETFORM_LABELS",
            payload: payload
        }
    },
    getFormAndTaxYearList: (payload) => {
        return {
            type: "QBO/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "QBO/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "QBO/GET_FORM_SETTING",
            payload: payload
        }
    },
}

function* getQboUrlAsync() {
    try {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.qboIndex();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setQboAuthorizationUrl(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Qbo Url", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* connectToQboAsync(action) {
    try {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.GRID_LOADING }));
        const { qboSearchParams } = action.payload;
        const response = yield IntegrationDataService.connectToQbo(qboSearchParams);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setBusinessList(response?.data.Data));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to Connect QBO", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* disconnectToQboAsync(action) {
    try {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.GRID_LOADING }));
        const { removedrealmId, initialState } = action.payload;
        const response = yield IntegrationDataService.disconnectQbo(removedrealmId);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            const updatedList = initialState.filter(r => r.Value !== removedrealmId);
            yield put(setBusinessList(updatedList));
            yield put(addNotifications({ heading: "Disconnected", message: "You have been successfully disconnected.", variant: TOASTER_VARIANT.SUCCESS }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to Disconnect QBO", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* getChartOfAccountsAsync(action) {
    try {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.GRID_LOADING }));
        const { qboRequestDto } = action.payload;
        const response = yield IntegrationDataService.getCOATypes(qboRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setChartOfAccounts(response?.data?.Data));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch COA", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.GRID_DATA_READY }));
    }
}
function* getFormLabelsAsync() {
    try {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.MATCHFIELDS_LOADING }));
        const response = yield IntegrationDataService.getFormLabels();
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setFormBoxLabels(response?.data?.Data));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Form Labels", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.MATCHFIELDS_DATA_READY }));
    }
}
function* getFormAndTaxYearListAsync() {
    try {
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            const formAndTaxYearData = response?.data?.Data || {};
            yield put(setFormAndTaxYearList(formAndTaxYearData));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch TaxYear And Form Types", message: error?.response?.data?.Message }));
    }
}
function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.MATCHFIELDS_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setImportData(response?.data?.Data));
            yield put(setIsImportDataGridViewLoaded(true));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.MATCHFIELDS_DATA_READY }));
    }
}
function* getFormSettingAsync(action) {
    try {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.MATCHFIELDS_LOADING }));
        const { formId, year } = action.payload;
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setFormSettings(response?.data?.Data));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: QBO_LOADING_STATES.MATCHFIELDS_DATA_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getQboUrl().type, getQboUrlAsync),
        takeLatest(connectToQbo().type, connectToQboAsync),
        takeLatest(disconnectToQbo().type, disconnectToQboAsync),
        takeLatest(getChartOfAccounts().type, getChartOfAccountsAsync),
        takeLatest(getFormLabels().type, getFormLabelsAsync),
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
    ]);
}


store.sagaManager.addSaga(qboComponentKey, rootSaga);